import { Col, Row, Divider, Select } from "antd";
import HEARTBEAT from "../../../../assets/images/icons/heartbeat.svg";
import CardCollapse from "../../../Common/CardCollapse";
import { VEHICLE_STATUS } from "../../../Common/Grafana/Constants";
import { useEffect, useState } from "react";
import ChartFilter from "../../../Common/ChartFilter";
import PanelsRow from "../../../Common/Grafana/PanelsRow";
import panelList from "../panelList.json";

const telemetryFields = panelList.telemetryFields

const TelemetryPanels = ({
  baseUrl,
  baseFilterObject,
  variableKeys,
}) => {
  const [chartType, setChartType] = useState({
    timeSeries: true,
    histogram: false,
    boxPlot: false,
  });
  const [telemetryList, setTelemetryList] = useState([]);

  useEffect(() => {
    setTelemetryList([telemetryFields?.[0]?.value]);
  }, []);

  const updateChartType = (name, value) => {
    setChartType((prev) => ({ ...prev, [name]: value }));
  };

  const onSelectTelemetry = (selectedValues) => {
    setTelemetryList(selectedValues);
  };

  const subContent = (
    <>
      <Row gutter={[16, 16]} justify="space-between" className="mt05">
        <Col xs={24} sm={24} md={16} lg={10} xl={10}>
          <Select
            value={telemetryList}
            mode="tags"
            style={{ width: "100%" }}
            onChange={onSelectTelemetry}
            options={telemetryFields?.map((i) => ({
              label: i.label,
              value: i.value,
            }))}
          />
        </Col>
        <Col xs={8} sm={6} md={4} lg={3} xl={3}>
          <ChartFilter
            updateChartType={updateChartType}
            chartType={chartType}
          />
        </Col>
      </Row>
      
    </>
  );

  return (
    <CardCollapse
      cardClassName="vehicle-status-analytics-card"
      icon={HEARTBEAT}
      title={"Telemetry Analytics"}
      subContent={subContent}
    >
      <Row className="pd0">
        {telemetryList?.map((panel, index) => (
          <Col key={index} span={24}>
            <PanelsRow
              title={panel}
              url={baseUrl}
              timeSeriesPanel={
                chartType?.timeSeries &&
                VEHICLE_STATUS.PANEL_ID[panel]["timeSeries"]
              }
              histogramPanel={
                chartType?.histogram &&
                VEHICLE_STATUS.PANEL_ID[panel]["histogram"]
              }
              boxPlotPanel={
                chartType?.boxPlot &&
                VEHICLE_STATUS.PANEL_ID[panel]["boxPlot"]
              }
              baseFilterObject={baseFilterObject}
              staticFilterObject={{telemetryfield: panel}}
              variableKeys={[...variableKeys, ...VEHICLE_STATUS.TELEMETRY_VARIABLES]}
            />
            {telemetryList?.length !== index + 1 ? (
              <Divider className="compare-divider" />
            ) : null}
          </Col>
        ))}
      </Row>
    </CardCollapse>
  );
};

export default TelemetryPanels;
